var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoActionReport = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_actions",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reload"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27877",
    "data-name": "Group 27877"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27876",
    "data-name": "Group 27876"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47056",
    "data-name": "Path 47056",
    d: "M14.514,5.007,13.85.436a.472.472,0,0,0-.8-.261l-.967.951A8.029,8.029,0,0,0,7.979,0,7.873,7.873,0,0,0,0,7.65a.464.464,0,0,0,.4.469l1.876.264a.467.467,0,0,0,.536-.464A5.123,5.123,0,0,1,7.979,2.77,5.241,5.241,0,0,1,10,3.176l-.932.917a.46.46,0,0,0,.265.784l4.648.653A.466.466,0,0,0,14.514,5.007Z",
    fill: "#00a1af"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27879",
    "data-name": "Group 27879",
    transform: "translate(1.463 7.651)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27878",
    "data-name": "Group 27878"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47057",
    "data-name": "Path 47057",
    d: "M61.65,241.028l-1.875-.263a.5.5,0,0,0-.536.5,5.128,5.128,0,0,1-5.164,5.079,5.246,5.246,0,0,1-2.013-.4l.9-.887a.46.46,0,0,0-.265-.784l-4.647-.653a.467.467,0,0,0-.531.523l.664,4.571a.472.472,0,0,0,.8.261l.99-.973a8.048,8.048,0,0,0,4.1,1.116,7.882,7.882,0,0,0,7.978-7.612A.465.465,0,0,0,61.65,241.028Z",
    transform: "translate(-47.516 -240.761)",
    fill: "#00a1af"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoActionReport);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_action_report.7b0ff30977c24d2f5d0d04ae5ff927a5.svg";